export const getSimLetter = (sim, simSuppliers) => {
  const matchingSimSupplier = simSuppliers.find(simSupplier => simSupplier.isActive && sim.startsWith(simSupplier.prefix));
  return matchingSimSupplier && matchingSimSupplier.letter;
};